import { createSlice } from "@reduxjs/toolkit";
import { getLanguage, getAllDepartment, getHospitalPfp, uploadMedia, addDoctor, editDoctor } from "./AddDoctorThunk";

const initialState = {
  getLangSuccess: null,
  getLangErr: null,
  getAllDepSuccess: null,
  getAllDepErr: null,
  getHospitalPfpSuccess:null,
  getHospitalPfpErr:null,
  uploadMediaSuccess:null,
  uploadMediaErr: null,
  addDoctorSuccess: null,
  addDoctorErr: null,
  editDocSuccess: null,
  editDocErr: null
};

const addDoctorSlice = createSlice({
  name: "addDoctorSlice",
  initialState,
  reducers: {
    resetGetLang(state) {
      state.getLangSuccess = null;
      state.getLangErr = null;
    },
    resetGetAllDep(state) {
      state.getAllDepErr = null;
      state.getAllDepSuccess = null;
    },
    resetGetHospitalPfp(state){
      state.getHospitalPfpErr = null;
      state.getHospitalPfpSuccess = null;
    },
    resetUploadMedia(state){
      state.uploadMediaSuccess = null;
      state.uploadMediaErr = null;
    },
    resetAddDoctor(state){
      state.addDoctorErr = null;
      state.addDoctorSuccess =  null;
    },
    resetEditDoc(state){
      state.editDocErr = null;
      state.editDocSuccess= null;
    }
  },
  extraReducers: (builder) => {
    builder
      //  GET Langauge
      .addCase(getLanguage.fulfilled, (state, action) => {
        state.getLangSuccess = action.payload;
      })
      .addCase(getLanguage.rejected, (state, action) => {
        state.getLangErr = action.error.message;
      })
      // GET ALL DEPARTMENT
      .addCase(getAllDepartment.fulfilled, (state, action) => {
        state.getAllDepSuccess = action.payload;
      })
      .addCase(getAllDepartment.rejected, (state, action) => {
        state.getAllDepErr = action.error.message;
      })
      // GET HOSPITAL PROFILE
      .addCase(getHospitalPfp.fulfilled, (state, action) => {
        state.getHospitalPfpSuccess = action.payload;
      })
      .addCase(getHospitalPfp.rejected, (state, action) => {
        state.getHospitalPfpErr = action.error.message;
      })
      // UPLOAd Media
      .addCase(uploadMedia.fulfilled, (state, action) => {
        state.uploadMediaSuccess = action.payload;
      })
      .addCase(uploadMedia.rejected, (state, action) => {
        state.uploadMediaErr = action.error.message;
      })
      // ADD DOCTOR
      .addCase(addDoctor.fulfilled, (state, action) => {
        state.addDoctorSuccess = action.payload;
      })
      .addCase(addDoctor.rejected, (state, action) => {
        state.addDoctorErr = action.error.message;
      })
      // EDIT DOCTOR
      .addCase(editDoctor.fulfilled, (state, action) => {
        state.editDocSuccess = action.payload;
      })
      .addCase(editDoctor.rejected, (state, action) => {
        state.editDocErr = action.error.message;
      });
  },
});

export const { resetGetLang, resetGetAllDep, resetGetHospitalPfp, resetEditDoc, resetUploadMedia, resetAddDoctor } = addDoctorSlice.actions;
export default addDoctorSlice.reducer;
